import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Button, Box, Typography, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';

const LayoutUserHeader = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const gstNumber = localStorage.getItem('gstNumber');
  const firmName = localStorage.getItem('firmName');

  const menuLinks = [
    { label: 'Home', to: '/UserDashboard' },
    { label: 'Unit', to: '/Unit' },
    { label: 'Product', to: '/ProductList' },
    { label: 'Sale Invoice', to: '/GetSaleInvoices' },
    { label: 'Purchase Invoice', to: '/GetPurchaseInvoice' },
    { label: 'Payment Details', to: '/PaymentDetails' },
    { label: 'Logout', to: '/' }
  ];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const logout = () => {
    localStorage.removeItem('gstNumber');
    localStorage.removeItem('firmName');
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          px: 2,
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography
            variant="h6"
            component={Link}
            to="/UserDashboard"
            sx={{
              textDecoration: 'none',
              color: '#004080',
              fontWeight: 'bold',
              fontSize: '1.8rem',
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: '0.5px',
            }}
          >
            EASUP 
          </Typography>

          {!isMobile && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                bgcolor: '#e3f2fd',
                px: 2,
                py: 1,
                borderRadius: 2,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: '#004d40',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {firmName || 'Firm Name'} -
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  color: '#1b5e20',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {gstNumber || 'GST Number'}
              </Typography>
            </Box>
          )}

          {!isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {menuLinks.map((item, index) => {
                const isLogout = item.label === 'Logout';
                return (
                  <Button
                    key={index}
                    component={isLogout ? 'button' : Link}
                    to={isLogout ? undefined : item.to}
                    onClick={isLogout ? logout : undefined}
                    sx={{
                      color: isLogout ? '#ffffff' : '#333333',
                      backgroundColor: isLogout ? '#004080' : 'transparent',
                      fontWeight: isLogout ? 'bold' : 500,
                      fontSize: '1rem',
                      fontFamily: "'Poppins', sans-serif",
                      textTransform: 'none',
                      mx: 1.5,
                      borderRadius: isLogout ? '20px' : '0',
                      px: isLogout ? 2 : undefined,
                      py: isLogout ? 1 : undefined,
                      '&:hover': {
                        color: isLogout ? '#ffffff' : '#004080',
                        backgroundColor: isLogout ? '#003366' : 'transparent',
                      },
                      display: 'flex',
                      alignItems: 'center',
                      gap: isLogout ? 1 : 0,
                    }}
                  >
                    {isLogout && <LogoutIcon sx={{ fontSize: '18px' }} />}
                    {item.label}
                  </Button>
                );
              })}
            </Box>
          ) : (
            <>
              <IconButton onClick={toggleDrawer(true)} edge="end">
                <MenuIcon sx={{ color: '#004080' }} />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 250, p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ color: '#004080' }}>Menu</Typography>
                    <IconButton onClick={toggleDrawer(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <List>
                    {menuLinks.map((item, index) => {
                      const isLogout = item.label === 'Logout';
                      return (
                        <ListItem key={index} disablePadding>
                          <ListItemButton
                            component={isLogout ? 'button' : Link}
                            to={isLogout ? undefined : item.to}
                            onClick={isLogout ? () => { logout(); setDrawerOpen(false); } : toggleDrawer(false)}
                          >
                            <ListItemText
                              primary={
                                isLogout ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <LogoutIcon sx={{ fontSize: '18px', color: '#004080' }} />
                                    {item.label}
                                  </Box>
                                ) : (
                                  item.label
                                )
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                </Box>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default LayoutUserHeader;
